// controls/text.js — version React Composant + JSON Schema native
import React, { useState, useEffect } from "react";
import CommonControls from "./inc/Common";
import { debug } from './../../../../utils';

/**
 * Création d’un champ texte conforme JSON Schema draft 2020-12
 */
export function createTextField() {
  return {
    type: "string",
    title: "Texte court",
    minLength: 0,
    maxLength: 255,
    pattern: "",
    "x-required": true,
    "x-readonly": false,
    "x-inputMode": "",
    "x-displayWidth": "",
    "x-placeholder": "",
    "x-ui": "text",
  };
}

/** 
 * Éditeur du champ texte (FieldEditor) — version composant React
 */
export function EditTextField({ field, onChange }) {
  const [min, setMin] = useState(field.minLength ?? 0);
  const [max, setMax] = useState(field.maxLength ?? 255);
  const [pattern, setPattern] = useState(field.pattern || "");
  const [inputMode, setInputMode] = useState(field["x-inputMode"] || "");
  const [placeholder, setPlaceholder] = useState(field["x-placeholder"] || "");

  // Synchronisation vers le parent (FormBuilder)
  useEffect(() => onChange("minLength", min), [min]);
  useEffect(() => onChange("maxLength", max), [max]);
  useEffect(() => onChange("pattern", pattern), [pattern]);
  useEffect(() => onChange("x-inputMode", inputMode), [inputMode]);
  useEffect(() => onChange("x-placeholder", placeholder), [placeholder]);

  return (
    <>
      <CommonControls field={field} onChange={onChange} />

      {/* ---- Longueurs ---- */}
      <div className="mb-3">
        <label className="form-label">Longueur minimale</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          value={min}
          onChange={(e) => setMin(Number(e.target.value))}
          placeholder="ex : 3"
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Longueur maximale</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          value={max}
          onChange={(e) => setMax(Number(e.target.value))}
          placeholder="ex : 255"
        />
      </div>

      {/* ---- Pattern ---- */}
      <div className="mb-3">
        <label className="form-label">Motif de validation (regex)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="ex : ^[A-Za-z0-9_]+$"
          value={pattern}
          onChange={(e) => setPattern(e.target.value)}
        />
        <small className="text-muted">
          Optionnel — pour restreindre le format autorisé (regex JavaScript).
        </small>
      </div>

      {/* ---- Clavier mobile / inputMode ---- */}
      <div className="mb-3">
        <label className="form-label">Mode de saisie (mobile)</label>
        <select
          className="form-select form-select-sm"
          value={inputMode}
          onChange={(e) => setInputMode(e.target.value)}
        >
          <option value="">Défaut</option>
          <option value="text">Texte</option>
          <option value="numeric">Numérique</option>
          <option value="decimal">Décimal</option>
          <option value="tel">Téléphone</option>
          <option value="email">Email</option>
          <option value="url">URL</option>
        </select>
      </div>

      {/* ---- Placeholder ---- */}
      <div className="mb-3">
        <label className="form-label">Texte indicatif (placeholder)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="ex : votre nom"
          value={placeholder}
          onChange={(e) => setPlaceholder(e.target.value)}
        />
      </div>
    </>
  );
}

/** 
 * Compatibilité avec le FieldEditorRegistry
 */
export const editTextField = (props) => <EditTextField {...props} />;
/* =========================================================
   🧩 FRONT — rendu du champ texte
   ========================================================= */
export const RenderTextField = ({
  field,
  value,
  onChange,
  onBlur = null,
  className,
  isReadOnly,
  errors   // valeur string éventuelle : "Champ requis"
}) => {

  const placeholder = field["x-placeholder"] || "";
  const inputMode = field["x-inputMode"] || "";
  const minLength = field.minLength ?? 0;
  const maxLength = field.maxLength ?? 255;
  const pattern = field.pattern || "";
  const isRequired =
    field["x-effective-required"] === true ||
    field["x-required"] === true;
  return (
    <div
      className={`
        fb-field fb-text
        ${isRequired ? "fb-required" : ""}
        ${field["x-bloc-class"] || ""}
        ${className || ""}
      `}
    >
      {/* Label */}
      {field.title && (
        <label className="form-label">
          {field.title}
        </label>
      )}

      {/* Input text */}
      <input
        type="text"
        className={`
          form-control
          ${field["x-control-class"] || ""}
          ${errors ? "is-invalid" : ""}
          ${isReadOnly || field['x-readonly'] === true ? 'readOnly' : ''}
        `}
        placeholder={placeholder}
        inputMode={inputMode}
        value={value || field['value']}
        minLength={minLength}
        readOnly={isReadOnly || field['x-readonly'] === true}
        name={field.name}
        maxLength={maxLength}
        pattern={pattern}
        onChange={(e) => onChange?.(e.target.value)}
        onBlur={onBlur ? onBlur : null}
      />
    </div>
  );
};
